import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { FormattedMessage } from 'react-intl';

import style from '../grid-header/shared-classes.module.less';

// the menu items are a separate component to allow for overflow
// never use the menu component directly, use its container:
// src/containers/orders-allocation-button-container/menu-items-container
const AllocateButton = ({ shouldBeDisabled, children }) => {
  return (
    <DropdownMenu
      className={classnames(style['allocate-dropdown-menu'], style['action-bar-button'])}
      disabled={shouldBeDisabled}
      dropdownMenuClassName={style['dropdown-menu']}
      menuPosition='bottom-right'
    >
      <DropdownMenuToggler theme='tertiary'>
        <FormattedMessage defaultMessage='Allocate' description='orderGridOtherActions.allocate' id='i8KYBb' />
      </DropdownMenuToggler>
      {children}
    </DropdownMenu>
  );
};

AllocateButton.propTypes = {
  shouldBeDisabled: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default AllocateButton;
